import React from "react"
import { Navigate, useLocation, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"

//constants
import { layoutTypes } from "../../constants/layout"

const Authmiddleware = props => {
  const { layoutType } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
  }))

  const getLayout = layoutType => {
    let Layout = VerticalLayout
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout
        break
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout
        break
      default:
        break
    }
    return Layout
  }

  const Layout = getLayout(layoutType)
  if (!localStorage.getItem("authUser")) {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const isFrom = searchParams.get("is_from");

    // Extract the ID from the pathname using a regex
    const match = location.pathname.match(/\/sales-order\/(\d+)/);
    const id = match ? match[1] : null;

    const loginSearchParams = new URLSearchParams();
    if (isFrom) loginSearchParams.set("is_from", isFrom);
    if (id) loginSearchParams.set("id", id);
    if(isFrom && id){
        return(
          <Navigate
            to={{
              pathname: "/login",
              search: `?${loginSearchParams.toString()}`,
            }}
            state={{ from: location }}
            replace
          />
        )
    }else{
      
      return (
        <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
      )
    }
    
  } else {
    let permissions = JSON.parse(localStorage.getItem("authUser"))?.permissions
    if (
      props?.path === "/roles" ||
      props?.path === "/new-role" ||
      props?.path === "/edit-role"
    ) {
      //1 = roles (organization)
      if (permissions?.filter(x => x.resource_id == 1)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/user-list") {
      //2 = users (organization)
      if (permissions?.filter(x => x.resource_id == 2)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/vendors" ||
      props?.path === "/add-vendor" ||
      props?.path === "/edit-vendor"
    ) {
      //3 = vendors (organization)
      if (permissions?.filter(x => x.resource_id == 3)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/customers" ||
      props?.path === "/add-customer" ||
      props?.path === "/edit-customer"
    ) {
      if (permissions?.filter(x => x.resource_id == 4)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/purchase-order" ||
      props?.path === "/add-purchase-order" ||
      props?.path === "/edit-purchase-order"
    ) {
      //5 = purchase-order (organization)
      if (permissions?.filter(x => x.resource_id == 5)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    }else if (
      props?.path === "/bills-organisation" ||
      props?.path === "/add-bill-organisation"
    ) {
      //6 = vendor-bill (organization)
      if (permissions?.filter(x => x.resource_id == 6)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/shipments-organisation" ||
      props?.path === "/add-shipment-organisation"
    ) {
      //7 = vendor-shipment (organization)
      if (permissions?.filter(x => x.resource_id == 7)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/payment-organisation" ||
      props?.path === "/add-payment-organisation"
    ) {
      //8 = vendor-payment (organization)
      if (permissions?.filter(x => x.resource_id == 8)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/sales-order") {
      //9 = sales-order (vendor)
      if (permissions?.filter(x => x.resource_id == 9)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/packages" ||
      props?.path === "/add-package"
    ) {
      //10 = package (vendor)
      if (permissions?.filter(x => x.resource_id == 10)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/shipment" ||
      props?.path === "/add-shipment"
    ) {
      //11 = shipment (vendor)
      if (permissions?.filter(x => x.resource_id == 11)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/invoices" ||
      props?.path === "/add-invoice"
    ) {
      //12 = vendor-invoice (vendor)
      if (permissions?.filter(x => x.resource_id == 12)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/documents" ||
      props?.path === "/add-documents"
    ) {
      //13 = documents (all)
      if (permissions?.filter(x => x.resource_id == 13)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/purchase-order-customer" ||
      props?.path === "/add-purchase-order-customer" ||
      props?.path === "/edit-purchase-order-customer/:IdParam"
    ) {
      //14 = purchase-order (customer)
      if (permissions?.filter(x => x.resource_id == 14)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/bills") {
      //15 = bill (customer)
      if (permissions?.filter(x => x.resource_id == 15)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/shipment-customer") {
      //16 = shipment (customer)
      if (permissions?.filter(x => x.resource_id == 16)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/payments" ||
      props?.path === "/add-payments"
    ) {
      //17 = payment (customer)
      if (permissions?.filter(x => x.resource_id == 17)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/sales-order-organisation") {
      //18 = sales-order (organization)
      if (permissions?.filter(x => x.resource_id == 18)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (
      props?.path === "/packages-organisation" ||
      props?.path === "/add-package-organisation"
    ) {
      //19 = package (organization)
      if (permissions?.filter(x => x.resource_id == 19)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/shipment-organisation") {
      //20 = shipment (organization)
      if (permissions?.filter(x => x.resource_id == 20)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/sales-invoice") {
      //21 = sales-invoice (organization)
      if (permissions?.filter(x => x.resource_id == 21)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    } else if (props?.path === "/company-profile") {
      //22 = profile (all)
      if (permissions?.filter(x => x.resource_id == 22)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    }
    else if (props?.path === "/direct-shipment") {
      //22 = profile (all)
      if (permissions?.filter(x => x.resource_id == 23)?.length == 0) {
        return (
          <Navigate
            to={{ pathname: "/dashboard", state: { from: props.location } }}
          />
        )
      }
    }
  }

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  )
}

export default Authmiddleware
